type TCheckboxRef = HTMLDivElement & { isChecked: boolean }

enum ECheckboxVariant {
    Default
}

export type { TCheckboxRef }
export { ECheckboxVariant }
